import React, { useEffect, useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/Modal/GenericModal'
import Form from 'component/utils/Form'
import Select from 'component/Select/Select'
import Editor from 'component/HtmlEditor'
import Button from 'component/Button'
import VersionSelect from 'component/mobileUpdatesNew/VersionSelect'
import StoreSelect from 'component/mobileUpdatesNew/StoreSelect'
import PublishIcon from 'images/publish.svg'
import downloadIcon from 'images/download_white.svg'
import downloadIconGray from 'images/download_gray.svg'
import LdapInput from './LdapInput'
import { arraysEqual } from 'utils/validations'
import TextLink from 'component/TextLink'

const ENV = process.env.API_ENV

const commonConfig = {
  renderButton: true,
  showHeader: true,
  showFooter: true,
  confirmType: '',
  center: false,
  size: 'md',
}

export const MODAL_TYPE = {
  CREATE: {
    ...commonConfig,
    title: 'mobile.update.new.liberation.title',
  },
  EDIT: {
    ...commonConfig,
    title: 'mobile.update.new.liberation.title',
  },
  WRITE: {
    ...commonConfig,
    title: 'mobile.update.write.web.update',
  },
  REWRITE: {
    ...commonConfig,
    title: 'mobile.update.rewrite.web.update',
  },
  DOWNLOAD: {
    size: 'sm',
    center: true,
    renderButton: false,
    showFooter: false,
    title: 'mobile.update.download',
  },
  UPDATE: {
    size: 'sm',
    center: true,
    renderButton: false,
    showHeader: false,
    showFooter: false,
    title: 'mobile-update.update',
  },
  PUBLISH: {
    size: 'sm',
    center: true,
    renderButton: false,
    showHeader: false,
    showFooter: false,
    title: 'mobile.update.publish',
  },
  DELETE: {
    size: 'sm',
    center: true,
    renderButton: false,
    showHeader: false,
    showFooter: false,
    confirmType: 'danger',
    title: 'commonReport.delete',
  },
}

const FIELDS = ['updateNotes', 'idVersion', 'store', 'dsLdap', 'idBranch', 'dsBranch']

const MobileUpdatesModal = (props) => {
  const {
    closeModal,
    handleDelete,
    handleSubmit,
    handleUpdate,
    handlePublish,
    data,
    type,
    setValueToField,
    translate,
    values,
    mobileUpdates,
    user,
    apkDownloadUrl,
  } = props

  const [copied, setCopied] = useState(false)
  const [dsBranch,setDsBranch] = useState("")
  useEffect(() => {
    if (data) {
      data.updateNotes && setValueToField('updateNotes', data.updateNotes)
      data.idVersion && setValueToField('idVersion', data.idVersion)
      data.store && setValueToField('store', data.store)
      data.dsBranch && setDsBranch(data.dsBranch)
      data.idBranch && setValueToField('idBranch', data.idBranch)
      data.dsLdap && data.dsLdap.length > 0 && setValueToField('dsLdap', data.dsLdap[0].split(","))
    }
  }, [])

  const hasRequiredFieldEmpty = (type) => {
    const validator = (fields) =>
      fields.reduce((accumulator, field) => {
        const validation = (values[field] || '').length === 0

        return accumulator || validation
      }, false)

    switch (type) {
      case MODAL_TYPE.CREATE:
      case MODAL_TYPE.EDIT:
      case MODAL_TYPE.DOWNLOAD:
        return validator(['idVersion'])
      case MODAL_TYPE.WRITE:
      case MODAL_TYPE.REWRITE:
        return validator(['updateNotes'])
      default:
        return false
    }
  }

  const hasSameValues = (type) => {
    const validator = (fields) =>
      fields.reduce((accumulator, field) => {
        const validation =
          data &&
          (typeof values[field] === 'object'
            ? arraysEqual(data[field], values[field])
            : data[field] === values[field])

        return accumulator && validation
      }, true)

    switch (type) {
      case MODAL_TYPE.WRITE:
      case MODAL_TYPE.REWRITE:
        return validator(['updateNotes'])
      case MODAL_TYPE.CREATE:
      case MODAL_TYPE.EDIT:
        return validator(['idVersion', 'store', 'dsLdap', 'updateNotes'])
      default:
        return false
    }
  }

  const convertToVersionCode = (versionName) =>  {
    const parts = versionName.split('.');
    // Extrai os valores de major, minor e patch
    const major = parseInt(parts[0], 10);
    const minor = parseInt(parts[1], 10);
    const patch = parseInt(parts[2], 10);
    // Calcula o versionCode
    const versionCode = (major * 1000000) + (minor * 100000) + patch;
    return versionCode;
  }

  const constructDynamicApkUrl = (versionName) => {
    if (!apkDownloadUrl || !versionName) {
      return null;
    }

    const bucketEnvMapping = ENV === 'developer' ? 'dev'
      : ENV === 'homologation' ? 'hml'
      : ENV === 'production' ? 'prd'
      : 'dev';

    const envMapping = ENV === 'developer' ? 'dev' 
      : ENV === 'homologation' ? 'homologacao'
      : ENV === 'production' ? 'producao'
      : 'dev';

    const versionCode = convertToVersionCode(versionName);
    const fullVersionName = `app-leroy-${envMapping}-${versionCode}`;

    return apkDownloadUrl
      .replace('{environment}', bucketEnvMapping)
      .replace('{version_name}', fullVersionName);
  }

  const renderContent = () => {
    switch (type) {
      case MODAL_TYPE.CREATE:
      case MODAL_TYPE.EDIT:
        return (
          <div className='w-100'>
            <VersionSelect
              user={user}
              onChange={({ label }) => {
                setValueToField('idVersion', label)
              }}
              translate={translate}
              value={values.idVersion}
            />
            <LdapInput
              values={values.dsLdap}
              onChange={(value) => {
                setValueToField('store', [])
                setValueToField('idBranch', [])
                setValueToField('dsBranch', [])
                setDsBranch("")
                !(values.dsLdap || []).some((dsLdap) => dsLdap === value) &&
                  setValueToField(
                    'dsLdap',
                    values.dsLdap ? [...values.dsLdap, value] : [value]
                  )

              }}
              removeOption={(index) => {
                const copy = Array.from(values.dsLdap)
                copy.splice(index, 1)
                setValueToField('dsLdap', copy)
              }}
              translate={translate}
            />
            <StoreSelect
              onChange={(option) => {
                setValueToField('store', option.value)
                setValueToField("idBranch", option.value)
                setValueToField("dsBranch", option.label)
                setDsBranch(option.label)
                setValueToField('dsLdap', [])
              }}
              user={user}
              translate={translate}
              value={values.idBranch}
              excludeInactive={true}
            />
            <span className='input-container-label'>
              {translate('mobile.update.html.label').concat(' - ')}
              <i>{translate('optional')}</i>
            </span>
            <Editor
              placeholder={translate('mobile.update.html.placeholder')}
              height={200}
              value={values.updateNotes}
              onTextChange={({ htmlValue }) =>
                setValueToField('updateNotes', htmlValue)
              }
            />
          </div>
        )
      case MODAL_TYPE.WRITE:
      case MODAL_TYPE.REWRITE:
        return (
          <div className='w-100 padding-top'>
            <span className='input-container-label'>
              {translate('mobile.update.html.label')}
            </span>
            <Editor
              placeholder={translate('mobile.update.html.placeholder')}
              value={values.updateNotes}
              onTextChange={({ htmlValue }) =>
                setValueToField('updateNotes', htmlValue)
              }
            />
          </div>
        )
      case MODAL_TYPE.DOWNLOAD:
        const updatesFiltered = [

          ...mobileUpdates.filter((update) => update.idVersion),
        ]
        const versionOptions = updatesFiltered.map((update, index) => ({
          label: update.idVersion,
          value: index,
        }))

        const catchDownloadLink = (version) => {
          const update = updatesFiltered.find(
            (option) => option.idVersion === version
          )

          if(update) {
            const dynamicUrl = constructDynamicApkUrl(update.idVersion);
            if (dynamicUrl) {
              return dynamicUrl;
            }
            
            const versionCode = convertToVersionCode(update.idVersion);


            const linkConcat = ENV === "homologation"
              ? "https://lmbr-mobilidade-apk.s3.sa-east-1.amazonaws.com/app-leroy-homologacao-"
              : ENV === "production"
              ? "https://lmbr-mobilidade-apk.s3.sa-east-1.amazonaws.com/app-leroy-producao-"
              : "https://lmbr-mobilidade-apk.s3.sa-east-1.amazonaws.com/app-leroy-developer";
            const apk = `${linkConcat}${versionCode}.apk`
            return update && apk
          }

          return update && update.downloadLink
        }

        return (
          <div className='confirmation-modal no-padding'>
            <Select
              label={translate('mobile.update.download.apk.version')}
              options={versionOptions}
              placeholder={translate('mobile-update.version-info')}
              translate={translate}
              onChange={({ label }) => setValueToField('idVersion', label)}
              value={versionOptions.find(
                (option) => option.label === values.idVersion
              )}
              required
              containerClass='text-align-left-no-color margin-top'
              fill
              validateValue={(v) => Boolean(v)}
            />
            {values.idVersion && (
              <Fragment>
                <span className='text-align-left-no-color margin-bottom-small'>
                  <strong className='margin-right-small'>
                    {translate('Link para baixar versão')}
                  </strong>
                  {catchDownloadLink(values.idVersion) && (
                    <TextLink
                      isNotClickable={copied}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          catchDownloadLink(values.idVersion)
                        )
                        setCopied(true)
                        setTimeout(() => setCopied(false), 3000)
                      }}
                      text={
                        copied
                          ? translate('mobile.update.download.apk.copied')
                          : translate('mobile.update.download.apk.copy')
                      }
                    />
                  )}
                </span>
                {catchDownloadLink(values.idVersion) ? (
                  <span className='text-align-left-no-color margin-bottom word-break'>
                    {catchDownloadLink(values.idVersion)}
                  </span>
                ) : (
                  <span className='text-align-left-no-color margin-bottom color-danger'>
                    {translate('mobile.update.download.apk.link.error')}
                  </span>
                )}
              </Fragment>
            )}
            <div className='button-row'>
              <Button
                className='btn custom-modal-close-button'
                text={translate('close_button_label')}
                onClick={closeModal}
              />
              <Button
                className='btn btn-primary'
                disabled={!catchDownloadLink(values.idVersion)}
                text={translate('mobile.update.download.apk.lowercase')}
                onClick={() =>
                  window.open(catchDownloadLink(values.idVersion), '_blank')
                }
                icon={
                  !catchDownloadLink(values.idVersion)
                    ? downloadIconGray
                    : downloadIcon
                }
              />
            </div>
          </div>
        )
      case MODAL_TYPE.UPDATE:
        return (
          <div className='confirmation-modal'>
            <i className='glyph glyph-refresh margin-bottom' />
            <p className='title no-margin'>{translate(type.title)}</p>
            <h4 className='margin-top margin-bottom'>
              {translate('mobile.update.update.now.message')}
            </h4>
            <span className='margin-bottom-small show'>
              <span>
                <strong>{`${translate('mobile-update.version')}: `}</strong>
                {`${data.idVersion}`}
              </span>
            </span>
            {data.dsLdap && data.dsLdap.length === 1 ? (
              <span className='margin-bottom-small show'>
                <span>
                  <strong>{`${translate('mobile.updates.ldap')}: `}</strong>
                  {`${data.dsLdap}`}
                </span>
              </span>
            ) : <span>
                  <strong>{`${translate('mobile.updates.ldap')}: `}</strong>
                  Todos
                </span>}
            <div className='button-row'>
              <Button
                className='btn custom-modal-close-button'
                text={translate('close_button_label')}
                onClick={closeModal}
              />
              <Button
                className='btn btn-primary'
                text={translate('mobile.update.update.now.confirmation')}
                onClick={() => handleBeforeUpdate(data)}
              />
            </div>
          </div>
        )
      case MODAL_TYPE.PUBLISH:
        return (
          <div className='confirmation-modal'>
            <img src={PublishIcon} className='margin-bottom' />
            <p className='title no-margin'>{translate(type.title)}</p>
            <h4 className='margin-top margin-bottom'>
              {translate('mobile.update.write.web.updates.message')}
            </h4>
            <div className='button-row'>
              <Button
                className='btn custom-modal-close-button'
                text={translate('close_button_label')}
                onClick={closeModal}
              />
              <Button
                className='btn btn-primary'
                text={translate('mobile.update.write.web.updates.confirmation')}
                onClick={() => handleBeforePublish(data.idUpdate)}
              />
            </div>
          </div>
        )
      case MODAL_TYPE.DELETE:
        return (
          <div className='remove-modal '>
            <i className='glyph glyph-trash-can color-danger margin-bottom' />
            <p className='title no-margin'>{translate(type.title)}</p>
            <h4 className='margin-top margin-bottom'>
              {translate('mobile.update.delete.message')}
            </h4>
            <span className='margin-bottom-small show'>
              <span>
                <strong>{`${translate('mobile-update.version')}: `}</strong>
                {`${data.idVersion}`}
              </span>
            </span>
            {data.dsLdap && data.dsLdap.length === 1 ? (
              <span className='margin-bottom-small show'>
                <span>
                  <strong>{`${translate('mobile.updates.ldap')}: `}</strong>
                  {`${data.dsLdap}`}
                </span>
              </span>
            ): <span>
                  <strong>{`${translate('mobile.updates.ldap')}: `}</strong>
                  Todos
                </span>
            }
            <div className='button-row'>
              <Button
                className='btn custom-modal-close-button'
                text={translate('close_button_label')}
                onClick={closeModal}
              />
              <Button
                className='btn btn-danger'
                text={translate('button.yes.remove.subtype')}
                onClick={() => handleBeforeDelete(data)}
              />
            </div>
          </div>
        )
      default:
        return <div />
    }
  }

  const handleBeforeSubmit = () => {
    const hasValue = {}

    FIELDS.forEach((field) => {
      if (values[field] && values[field].length) hasValue[field] = values[field]
    })

    if(dsBranch) {
      hasValue.dsBranch = dsBranch
    }

    if(data && data.idUpdate)
      handleSubmit(hasValue, data.idUpdate)
    else
      handleSubmit(hasValue)
  }

  const handleBeforeDelete = (data) => {
    handleDelete(data)
  }

  const handleBeforeUpdate = (data) => {
    handleUpdate(data)
  }

  const handleBeforePublish = (data) => {
    handlePublish(data)
  }

  return (
    <Modal
      title={translate(type.title)}
      size={type.size}
      isOpen
      onCloseModal={closeModal}
      className="release-update-modal-size"
      disabledBgClickClosing
      buttonClass='new-login-error-modal-button'
      onConfirm={() => handleBeforeSubmit()}
      cancelButtonText={translate('close_button_label')}
      showHeader={type.showHeader}
      showFooter={type.showFooter}
      center={type.center}
      confirmType={type.confirmType}
      confirmButtonText={translate('save_button_label')}
      isConfirmButtonDisabled={
        hasRequiredFieldEmpty(type) || hasSameValues(type)
      }
    >
      {renderContent()}
    </Modal>
  )
}

MobileUpdatesModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  handlePublish: PropTypes.func.isRequired,
  data: PropTypes.object,
  type: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object,
  mobileUpdates: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  apkDownloadUrl: PropTypes.string,
}

export default Form({ fields: FIELDS })(MobileUpdatesModal)

export { MobileUpdatesModal }
